import { TransactionTypeEnum } from "@/model/data/enums/TransactionTypeEnum";
import { IFilterInstallations } from "../supportObjects/IFilterInstallations";
import { IPaginationFilter } from "../supportObjects/IPaginationFilter";
import { GetTransactionListReqData } from "./GetTransactionListReqData";
import { TransactionsFilterData } from "./TransactionsFilterData";

export class ExportTransactionsReqData extends GetTransactionListReqData implements IFilterInstallations, IPaginationFilter {
    columns: string[];
}
